const styles = {
    layout: {
        display: 'flex',
    },
};
export default styles;
